export default "__VITE_ASSET__6YLItThI__"